export { PLUGIN_KEY, PLUGIN_PRIORITY, ManualColumnMove } from "./manualColumnMove.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnMove/index.mjs
// module id = 1456
// module chunks = 1